/**
 * Adapter do axios para respostas em streaming (application/x-ndjson, uma linha JSON por evento).
 *
 * Passa pelos interceptors do axios como qualquer requisição (token, renovação, HostName, 401, manutenção),
 * mas lê a resposta com fetch, linha a linha, à medida que chega. Cada linha vai para config.onStreamMessage;
 * a linha { type: 'result' } vira o data da resposta. config.streamSignal (AbortController) cancela.
 */

const readLines = async (response, onLine) => {
  // Sem leitura em partes (navegador antigo): lê tudo de uma vez no fim
  if (!response.body || !response.body.getReader) {
    const text = await response.text()
    text.split('\n').forEach((line) => {
      if (line.trim()) onLine(line)
    })
    return
  }

  const reader = response.body.getReader()
  const decoder = new TextDecoder()
  let buffer = ''

  for (;;) {
    const { done, value } = await reader.read()
    if (done) break

    buffer += decoder.decode(value, { stream: true })
    let newline = buffer.indexOf('\n')
    while (newline >= 0) {
      const line = buffer.slice(0, newline).trim()
      buffer = buffer.slice(newline + 1)
      if (line) onLine(line)
      newline = buffer.indexOf('\n')
    }
  }

  buffer += decoder.decode()
  if (buffer.trim()) onLine(buffer.trim())
}

const headersOf = (config) => {
  const headers = {}
  Object.keys(config.headers || {}).forEach((key) => {
    const value = config.headers[key]
    if (value !== undefined && value !== null && value !== '' && typeof value !== 'object')
      headers[key] = value
  })
  headers.Accept = 'application/x-ndjson'
  return headers
}

export const ndjsonAdapter = async (config) => {
  const response = await fetch(config.url, {
    method: (config.method || 'get').toUpperCase(),
    headers: headersOf(config),
    signal: config.streamSignal,
  })

  const responseHeaders = {}
  response.headers.forEach((value, key) => {
    responseHeaders[key] = value
  })

  if (!response.ok) {
    let data = {}
    try {
      const text = await response.text()
      data = (text && JSON.parse(text)) || {}
    } catch (e) {
      data = {}
    }

    const error = new Error(`o servidor respondeu ${response.status}`)
    error.config = config
    error.response = {
      status: response.status,
      statusText: response.statusText,
      headers: responseHeaders,
      data,
      config,
    }
    throw error
  }

  let result = null
  await readLines(response, (line) => {
    const message = JSON.parse(line)
    if (message.type === 'result') result = message.result || {}
    else if (config.onStreamMessage) config.onStreamMessage(message)
  })

  if (!result) throw new Error('a verificação terminou sem resposta final')

  return {
    data: result,
    status: response.status,
    statusText: response.statusText,
    headers: responseHeaders,
    config,
    request: null,
  }
}
